/** Decorative downloads must never prevent the room itself from rendering. */
export async function optionalPreviewAsset(load:()=>Promise<unknown>, timeoutMs=3000):Promise<void>{
 let timer:ReturnType<typeof setTimeout>|undefined;
 try{
  await Promise.race([
   Promise.resolve().then(load).catch(()=>undefined),
   new Promise<void>(resolve=>{timer=setTimeout(resolve,timeoutMs);}),
  ]);
 }finally{clearTimeout(timer);}
}
